module.exports = __webpack_public_path__ + "img/newtaiyo8.9c8a7372.png";